import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { DBConfig, NgxIndexedDBModule } from "ngx-indexed-db";
import { AppRoutingModule } from "./app-routing.module";
import { ErrorInterceptor } from "./_helpers/error.interceptor";
import { AppKeyInterceptor } from "./_helpers/app-key.interceptor";
import { AppComponent } from "./app.component";
import { GoogleAnalyticsService } from "./_services/google-analytics/google-analytics-service";
import { RedirectComponent } from "./redirect/redirect.component";
import { JWT_OPTIONS, JwtHelperService } from "@auth0/angular-jwt";
import { BrowserModule } from "@angular/platform-browser";
import { PRINCIPAL_SERVICE, provideAgentKit } from "@vision/viewer-components";
import { AuthenticationService } from "./_services/authentication.service";

const dbConfig: DBConfig = {
  name: "vexcel-data",
  version: 4,
  objectStoresMeta: [
    {
      store: "user-layers",
      storeConfig: { keyPath: "id", autoIncrement: false },
      storeSchema: [
        { name: "type", keypath: "type", options: { unique: false } },
      ],
    },
    {
      store: "user-properties",
      storeConfig: { keyPath: "requestId", autoIncrement: false },
      storeSchema: [
        { name: "type", keypath: "type", options: { unique: false } },
      ],
    },
    {
      store: "user-properties-damage-assessments",
      storeConfig: { keyPath: "requestId", autoIncrement: false },
      storeSchema: [
        { name: "type", keypath: "type", options: { unique: false } },
      ],
    },
  ],
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule, //
    HttpClientModule,
    RedirectComponent,
    NgxIndexedDBModule.forRoot(dbConfig),
  ],
  providers: [
    GoogleAnalyticsService,
    { provide: HTTP_INTERCEPTORS, useClass: AppKeyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    { provide: PRINCIPAL_SERVICE, useExisting: AuthenticationService },
    provideAgentKit({}),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
